/* eslint-disable no-unused-vars */
import img from '../img/progress2endnow.svg';

export default {
  id: 'progress2endnow',
  img,
  imgBg: 'linear-gradient(to right, #C7F9C5 0%, #C7F9C5 50%, #FFDDBC 50%, #FFDDBC 100%)',
  defaultConf() {
    return {};
  },
  canRun({ planning, element, oldData, newData, automation }) {
    const newProgress = parseInt(newData.progress, 10) || 0;
    if (newProgress != 100) return false;
    const oldProgress = parseInt(oldData.progress, 10) || 0;
    return oldProgress != newProgress;
  },
  run({ planning, element, oldData, newData, automation }, showToast) {
    if (showToast) showToast();
    element.setEndTime(moment());
    const startTime = element.getStartTime();
    if (startTime?.isAfter(moment())) {
      element.setStartTime(moment().add(-1, 'week'));
    }
  },
};
